import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import {
  fetchChavesApi, fetchEscoposApi, criarChaveApi, atualizarChaveApi, revogarChaveApi,
} from '../../api/apiChaves';
import './ChavesApi.css';

const ROTULO_ESCOPO = {
  'chamados:ler': 'Ler chamados',
  'chamados:criar': 'Criar chamados',
  'inventario:ler': 'Ler inventário',
  'sprints:ler': 'Ler sprints',
};

function ChavesApi() {
  const history = useHistory();
  const [lista, setLista] = useState([]);
  const [escopos, setEscopos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState('');
  const [show, setShow] = useState(false);
  const [nome, setNome] = useState('');
  const [escSel, setEscSel] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [novaChave, setNovaChave] = useState(null); // {chave, prefixo}

  const verificar = useCallback(async () => {
    const ok = await verificandoApp('ATENDENTE');
    if (!ok) history.push('/');
  }, [history]);

  const carregar = useCallback(async () => {
    verificandoToken();
    setLoading(true);
    const [l, e] = await Promise.all([fetchChavesApi(), fetchEscoposApi()]);
    setLista(l); setEscopos(e); setLoading(false);
  }, []);

  useEffect(() => { verificar(); carregar(); }, [verificar, carregar]);

  const abrirNova = () => { setNome(''); setEscSel([]); setNovaChave(null); setShow(true); setMensagem(''); };
  const toggleEsc = (e) => setEscSel((p) => p.includes(e) ? p.filter((x) => x !== e) : [...p, e]);

  const criar = async () => {
    setMensagem('');
    if (!nome.trim()) { setMensagem('Informe um nome.'); return; }
    if (escSel.length === 0) { setMensagem('Selecione ao menos um escopo.'); return; }
    setSalvando(true);
    try {
      const r = await criarChaveApi({ nome: nome.trim(), escopos: escSel });
      setNovaChave({ chave: r.chave, prefixo: r.prefixo });
      await carregar();
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao criar chave.');
    } finally { setSalvando(false); }
  };

  const alternarAtivo = async (c) => {
    try { await atualizarChaveApi(c.id, { ativo: !c.ativo }); carregar(); } catch (_) {}
  };
  const revogar = async (c) => {
    if (!window.confirm(`Revogar a chave "${c.nome}"? Sistemas que a usam deixarão de funcionar.`)) return;
    try { await revogarChaveApi(c.id); carregar(); } catch (_) {}
  };

  const copiar = (texto) => { try { navigator.clipboard.writeText(texto); setMensagem('Chave copiada.'); } catch (_) {} };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado chaves-api-page">
          <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div>
              <h1 className="mb-0"><i className="fas fa-key me-2" />Chaves de API</h1>
              <p className="text-muted small mb-0">Permitem que sistemas externos consumam a API pública (<code>/api/v1</code>). A chave completa é exibida apenas no momento da criação.</p>
            </div>
            <button type="button" className="btn btn-primary btn-sm" onClick={abrirNova}><i className="fas fa-plus me-1" />Nova chave</button>
          </div>

          {mensagem && <div className="alert alert-info py-2 mt-2">{mensagem}</div>}

          {loading ? <p className="text-muted">Carregando…</p> : lista.length === 0 ? (
            <div className="alert alert-info py-3 mt-2">Nenhuma chave de API criada.</div>
          ) : (
            <table className="table table-modern align-middle mt-2">
              <thead><tr><th>Nome</th><th>Prefixo</th><th>Escopos</th><th>Último uso</th><th>Ativa</th><th style={{ width: 150 }}>Ações</th></tr></thead>
              <tbody>
                {lista.map((c) => (
                  <tr key={c.id}>
                    <td>{c.nome}</td>
                    <td className="chaves-api-prefixo">{c.prefixo}…</td>
                    <td className="small">{(c.escopos || []).map((e) => ROTULO_ESCOPO[e] || e).join(', ') || '—'}</td>
                    <td className="small">{c.ultimo_uso ? new Date(c.ultimo_uso).toLocaleString('pt-BR') : 'nunca'}</td>
                    <td>
                      <button type="button" className={`btn btn-sm ${c.ativo ? 'btn-success' : 'btn-outline-secondary'}`} onClick={() => alternarAtivo(c)}>
                        {c.ativo ? 'Sim' : 'Não'}
                      </button>
                    </td>
                    <td>
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => revogar(c)} title="Revogar"><i className="fas fa-trash" /> Revogar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {show && (
            <div className="chaves-api-modal-overlay" onClick={() => setShow(false)}>
              <div className="chaves-api-modal" onClick={(e) => e.stopPropagation()}>
                {!novaChave ? (
                  <>
                    <h5>Nova chave de API</h5>
                    <div className="form-group mb-2">
                      <label>Nome</label>
                      <input type="text" className="form-control form-control-sm" value={nome} onChange={(e) => setNome(e.target.value)} maxLength={120} placeholder="Ex.: Integração ERP" />
                    </div>
                    <div className="form-group mb-3">
                      <label>Escopos (o que a chave pode fazer)</label>
                      <div className="chaves-api-escopos">
                        {escopos.map((e) => (
                          <label key={e} className="chaves-api-escopo-chip">
                            <input type="checkbox" checked={escSel.includes(e)} onChange={() => toggleEsc(e)} />
                            {ROTULO_ESCOPO[e] || e}
                          </label>
                        ))}
                      </div>
                    </div>
                    <div className="chaves-api-modal-acoes">
                      <button type="button" className="btn btn-link btn-sm" onClick={() => setShow(false)}>Cancelar</button>
                      <button type="button" className="btn btn-primary btn-sm" onClick={criar} disabled={salvando}>{salvando ? 'Criando…' : 'Criar chave'}</button>
                    </div>
                  </>
                ) : (
                  <>
                    <h5><i className="fas fa-check-circle text-success me-2" />Chave criada</h5>
                    <p className="small text-muted">Copie e guarde a chave agora. Por segurança, ela <strong>não será exibida novamente</strong>.</p>
                    <div className="chaves-api-chave-box">
                      <code>{novaChave.chave}</code>
                      <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => copiar(novaChave.chave)}><i className="fas fa-copy" /> Copiar</button>
                    </div>
                    <div className="chaves-api-modal-acoes mt-3">
                      <button type="button" className="btn btn-primary btn-sm" onClick={() => setShow(false)}>Concluído</button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default ChavesApi;
